import { CreatedTestRun } from '../models/test-run.model';

/**
 * Wohin ein frisch angelegter Lauf fuehrt (NEX-1042): in den Runner des Durchlaufs,
 * der beim Anlegen geoeffnet wurde. Die Lauf-Ebene selbst ist kein Ziel — dort steht
 * weder Pausieren noch Uebergeben noch die Kommentar-Historie, die zur Durchfuehrung
 * gehoeren.
 *
 * <p>Nennt die Antwort keinen Durchlauf — bei einer Repository-Quelle entsteht er
 * erst mit dem Import der Pipeline-Ergebnisse —, bleibt die Durchlauf-Ebene das Ziel.
 */
export function createdRunRoute(projectId: string, run: CreatedTestRun): string[] {
  const executions = ['/projects', projectId, 'test-runs', run.id, 'executions'];
  return run.executionId ? [...executions, run.executionId] : executions;
}
